import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('wizard.state.created'),
    },
    {
      id: 2,
      name: i18n.t('wizard.state.password_created'),
    },
    {
      id: 3,
      name: i18n.t('wizard.state.init'),
    },
    {
      id: 4,
      name: i18n.t('wizard.state.company_created'),
    },
    {
      id: 5,
      name: i18n.t('wizard.state.cert_created'),
    },
    {
      id: 6,
      name: i18n.t('wizard.state.verifactu'),
    },
    {
      id: 7,
      name: i18n.t('wizard.state.tutorial_finished'),
    },
    {
      id: 8,
      name: i18n.t('wizard.state.finished'),
    },
    {
      id: 9,
      name: i18n.t('wizard.state.finished_manual'),
    },
  ]
}

export function TIPOS_FASES_CONFIGURACION (state) {
  return configHelper.getConfig(state, 'TIPOS_FASES_CONFIGURACION', GenerateConfig)
}

